import { call, put, takeEvery } from 'redux-saga/effects';
import { LOAD_TRANSACTION_CATEGORIES, RECEIVE_TRANSACTION_CATEGORIES } from '../actions/transactionCategories'
import { API_PATH } from '../utilities/apiPath'

function* fetchTransactionCategories(action) {
  const token = action.token

  if (token) {
	  const endpoint = API_PATH + 'api/transactioncategories';
	  const options = {
		  headers: {
		    Authorization: `Bearer ${token}`
		  }

	  }
	  const response = yield call(fetch, endpoint, options);
	  const data = yield response.json();
	  yield put({ type: RECEIVE_TRANSACTION_CATEGORIES, transactionCategories: data });
	}
}

export function* loadTransactionCategories() {
  yield takeEvery(LOAD_TRANSACTION_CATEGORIES, fetchTransactionCategories);
}